import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCyberClose = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 33,
	fill: "currentColor",
	viewBox: "0 0 32 33",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M9.646 10.146a.5.5 0 0 1 .708 0l5.146 5.147 5.146-5.146a.5.5 0 0 1 .707.708L16.207 16l5.146 5.147a.5.5 0 0 1-.707.707L15.5 16.708l-5.147 5.147a.5.5 0 0 1-.707-.708l5.147-5.146-5.147-5.148a.5.5 0 0 1 0-.707",
		clipRule: "evenodd"
	})
});
export default SvgCyberClose;
